<script>
import AdminLayout from '@layouts/admin-main'
import LoginlogList from '@components/admin/loginlog-list'

export default {
  page: {
    title: 'Admin::LoginlogList',
    meta: [{ name: 'description', content: 'Admin::LoginlogList' }],
  },
  components: { AdminLayout, LoginlogList },
}
</script>

<template>
  <AdminLayout>
    <LoginlogList></LoginlogList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
